import { render } from "./BasicVehicleDetails.vue?vue&type=template&id=1179e93c&scoped=true"
import script from "./BasicVehicleDetails.vue?vue&type=script&lang=js"
export * from "./BasicVehicleDetails.vue?vue&type=script&lang=js"

import "./BasicVehicleDetails.vue?vue&type=style&index=0&id=1179e93c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/LCAP/LCAP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1179e93c"]])

export default __exports__